// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ed3eaf6b","749":"f189e5ab"}[chunkId] + ".chunk.js";
};